var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04281 33.8943H36.2553C37.5242 33.8943 38 33.4978 38 32.7047C38 31.9116 37.4448 31.4358 36.2553 31.4358H6.27705V8.19871L18.8869 3.75748V27.7876C18.8869 29.0565 21.4248 28.8186 21.4248 27.4704V2.01273C21.4248 1.06105 20.4731 0.823124 19.2042 1.21966C18.189 1.53689 15.1859 2.51501 13.8113 2.96442V0.743804C13.8113 -0.287192 11.3527 -0.207885 11.3527 0.743804V3.75748C9.6344 4.33907 5.99155 5.56569 5.16675 5.81947C4.13576 6.1367 3.73922 6.85047 3.73922 7.72285V31.4358H1.04281C-0.226104 31.4358 -0.464026 33.8943 1.04281 33.8943Z",
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1634,
    cy: 12.2431,
    r: 1.18961,
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1634,
    cy: 18.5883,
    r: 1.18961,
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.1634,
    cy: 24.9323,
    r: 1.18961,
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 12.2431,
    r: 1.18961,
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 18.5883,
    r: 1.18961,
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.239,
    cy: 24.9323,
    r: 1.18961,
    fill: "#1D183E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.201,
    y: 17.3987,
    width: 4.75844,
    height: 2.37922,
    rx: 1.18961,
    fill: "#00C385"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.201,
    y: 23.7427,
    width: 4.75844,
    height: 2.37922,
    rx: 1.18961,
    fill: "#00C385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.328 12.0059C24.1528 12.45 29.2761 14.7287 31.7346 15.8126V28.9776C31.7346 30.2466 34.1931 30.4052 34.1931 28.9776C34.1931 28.026 34.1138 15.8126 34.1931 15.1782C34.2724 14.5437 34.0345 13.9886 33.1621 13.592C32.2897 13.1955 25.6279 10.2611 24.2797 9.78525C22.9315 9.30941 22.297 11.4507 23.328 12.0059Z",
    fill: "#00C385"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployer);
export default __webpack_public_path__ + "static/media/employer.56fc22466b2fda63a2783751494328fc.svg";
export { ForwardRef as ReactComponent };